var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAccountBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 24 24",
    height: "24px",
    viewBox: "0 0 24 24",
    width: "24px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    fill: "none",
    height: 24,
    width: 24
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    height: 7,
    width: 3,
    x: 4,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    height: 7,
    width: 3,
    x: 10.5,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    height: 3,
    width: 20,
    x: 2,
    y: 19
  }), /*#__PURE__*/React.createElement("rect", {
    height: 7,
    width: 3,
    x: 17,
    y: 10
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "12,1 2,6 2,8 22,8 22,6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAccountBalance);
export default __webpack_public_path__ + "static/media/icon-account-balance.be1949d94df84110a511cb3086f722a7.svg";
export { ForwardRef as ReactComponent };